import { useNavigate } from 'react-router-dom'

import type { PublicPostSummary } from '@forbiz/contracts'

import { postsApi } from '../lib/posts.js'
import { useAsync } from '../lib/useAsync.js'
import s from './Posts.module.css'

/**
 * 소식 — 공지사항·이벤트 피드 (콘텐츠 도메인). 고정 글이 위, 그다음 최신순.
 * 카드를 누르면 상세로 간다. 데이터·노출 판정은 서버(활성·기간).
 */

function fmtDate(iso: string): string {
  const d = new Date(iso)
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`
}
const kindLabel = (k: PublicPostSummary['kind']) => (k === 'EVENT' ? '이벤트' : '공지')

export function NoticesPage() {
  const navigate = useNavigate()
  const { data, loading, error } = useAsync(() => postsApi.list(['NOTICE', 'EVENT']), [])
  const items = data?.items ?? []

  return (
    <div className={s.page}>
      <header className={s.head}>
        <h1 className={s.title}>소식</h1>
        <p className={s.lead}>공지와 이벤트를 한곳에서 확인하세요.</p>
      </header>

      {error ? (
        <p className={s.muted}>{error}</p>
      ) : loading ? (
        <p className={s.muted}>불러오는 중…</p>
      ) : items.length === 0 ? (
        <p className={s.muted}>아직 등록된 소식이 없어요.</p>
      ) : (
        <ul className={s.list}>
          {items.map((p, i) => (
            <li
              key={p.id}
              className={s.card}
              style={{ '--i': i } as React.CSSProperties}
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/notices/${p.id}`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  navigate(`/notices/${p.id}`)
                }
              }}
            >
              {p.imageUrl ? (
                <span className={s.thumb} style={{ backgroundImage: `url(${p.imageUrl})` }} aria-hidden="true" />
              ) : null}
              <span className={s.cardBody}>
                <span className={s.metaRow}>
                  <span className={p.kind === 'EVENT' ? `${s.badge} ${s.badgeEvent}` : s.badge}>{kindLabel(p.kind)}</span>
                  {p.isPinned ? (
                    <span className={s.pin} title="고정" aria-label="고정">
                      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M9 3.5h6l-.8 4.2 2.8 3v1.8H7v-1.8l2.8-3L9 3.5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                        <path d="M12 12.5v8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                      </svg>
                    </span>
                  ) : null}
                  <span className={s.date}>{fmtDate(p.publishedAt)}</span>
                </span>
                <span className={s.cardTitle}>{p.title}</span>
              </span>
              <span className={s.chevron} aria-hidden="true">›</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
